import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { ExcursionService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { Excursion } from '../../models'

const log = new Logger('ExcursionDetailResolver')
@Injectable({ providedIn: 'root' })
export class ExcursionDetailResolver implements Resolve<Observable<Excursion>> {
  constructor(
    private excursionService: ExcursionService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let eid = route.params['eid']
    
    return this.excursionService.getDetail(eid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/activity/excursion']))
    )
  }
}
